import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./_store";
import "@fortawesome/fontawesome-free/css/all.min.css";

// import "./registerServiceWorker";

import Buefy from "buefy";
// import "buefy/dist/buefy.css";

Vue.use(Buefy, {
  // defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
});

Vue.config.productionTip = false;

import moment from "vue-moment";
Vue.use(moment);

// import appLoading from "./components/app-loading";
// Vue.component("app-loading", appLoading);

// import appBack from "./components/app-back";
// Vue.component("app-back", appBack);

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("formatSlug", function(value) {
  if (!value) return "";
  value = value.toString().toLowerCase();
  value = value.replace("-", " ");
  value = value.split(" ");
  for (let index = 0; index < value.length; index++) {
    value[index] = value[index].charAt(0).toUpperCase() + value[index].slice(1);
  }
  return value.join(" ");
});

Vue.filter("formatMoney", function(n, c, d, t) {
  c = isNaN((c = Math.abs(c))) ? 2 : c;
  d = d == undefined ? "." : d;
  t = t == undefined ? "," : t;
  var s = n < 0 ? "-" : "";
  var i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c))));
  var j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
